export class Point {
	constructor(data) {
		this._id = data._id;
		this.id = data.id;
		this.points = data.points;
		this.add = data.add || false;
		this.subtract = data.subtract || false;
	}
}
